import Vue from 'vue'
import App from './App.vue'


import moment from 'moment';
moment.lang('es');
Vue.use(moment);

require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
});

// Resource
// ...
import VueResource from 'vue-resource';
Vue.use(VueResource);

// Store
// ...
import { store } from './store/store';


new Vue({
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js